import CommonEnrollItem, { EnrollItemProps as CommonEnrollItemProps } from '../EnrollItem';

export interface EnrollItemProps extends Omit<CommonEnrollItemProps, 'oktaButton' | 'factorDescription' | 'factorLabel' > {
  oktaFactorItem: JQuery;
  lastItem: boolean;
  isEnrolledFactor: boolean;
}

export default function EnrollItem({ oktaFactorItem, lastItem, isEnrolledFactor }: Readonly<EnrollItemProps>) {
  const label = oktaFactorItem.find('h3');
  const description = oktaFactorItem.find('p').eq(0);
  const oktaButton = oktaFactorItem.find('a.button');
  return (
    <CommonEnrollItem
      oktaFactorItem={oktaFactorItem}
      factorLabel={label.text()}
      factorDescription={description.text()}
      oktaButton={oktaButton}
      lastItem={lastItem}
      isEnrolledFactor={isEnrolledFactor}
    ></CommonEnrollItem>
  );
}
